import { render } from "./inspectiondetail.vue?vue&type=template&id=78410dca&scoped=true"
import script from "./inspectiondetail.vue?vue&type=script&lang=js"
export * from "./inspectiondetail.vue?vue&type=script&lang=js"

import "./inspectiondetail.vue?vue&type=style&index=0&id=78410dca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78410dca"]])

export default __exports__